export default __webpack_public_path__ + "static/media/mine.min.b651699b.png";